import { assert } from 'assert-ts';
import type { Command } from '#api/hosts.ts';
import { Button } from '#components/atoms/buttons/Button.tsx';
import { MeatballMenu, MenuItem } from '#components/patterns/menus/meatball-menu/index.ts';

type Props = {
  supportedCommands: string[];
  setCommandModal: (modalName: CommandModal) => void;
  onStartStream?: () => void;
  onDebugStack: () => void;
  variant: 'button' | 'icon';
};

export type CommandModal = Command;

export function DebugCommandMenu({ supportedCommands, setCommandModal, variant, onStartStream, onDebugStack }: Props) {
  assert(supportedCommands.length > 0, 'Expected host to have commands supported in DebugCommandMenu');

  return (
    <MeatballMenu
      gutter={8}
      menuButtonVariant={variant === 'button' ? 'minimal' : undefined}
      data-user-color-scheme="dark"
      aria-label="Debug commands"
      render={variant === 'button' ? <Button variant="icon" size="medium" /> : undefined}
    >
      {supportedCommands.includes('CreateTunnel') ?
        <MenuItem
          onClick={() => {
            setCommandModal('CreateTunnel');
          }}
        >
          Create tunnel
        </MenuItem>
      : null}
      {supportedCommands.includes('PrintTunnel') ?
        <MenuItem
          onClick={() => {
            setCommandModal('PrintTunnel');
          }}
        >
          Print tunnel
        </MenuItem>
      : null}
      {supportedCommands.includes('PrintCert') ?
        <MenuItem
          onClick={() => {
            setCommandModal('PrintCert');
          }}
        >
          Print cert
        </MenuItem>
      : null}
      {supportedCommands.includes('QueryLighthouse') ?
        <MenuItem
          onClick={() => {
            setCommandModal('QueryLighthouse');
          }}
        >
          Query lighthouse
        </MenuItem>
      : null}
      {supportedCommands.includes('DebugStack') ?
        <MenuItem disabled={!onDebugStack} onClick={onDebugStack}>
          Debug stack
        </MenuItem>
      : null}
      {supportedCommands.includes('StreamLogs') ?
        <MenuItem disabled={!onStartStream} onClick={onStartStream}>
          Stream logs
        </MenuItem>
      : null}
      {supportedCommands.includes('Restart') ?
        <MenuItem
          onClick={() => {
            setCommandModal('Restart');
          }}
        >
          Restart Nebula
        </MenuItem>
      : null}
    </MeatballMenu>
  );
}
